import { Link } from "react-router-dom";
import { Mixpanel } from "../../utils/mixpanel";

export const TrackedLink = (props) => {
  const properties = {...props}
  const name = properties.name;
  delete properties.name;

  const setTracking = () => {
    Mixpanel.track(name, {
      url: properties.to,
    });
  };
  return (
    <div onClick={setTracking}>
      <Link {...properties} />
    </div>
  );
};

export const TrackedButton = (props) => {
  const properties = {...props}
  const name = properties.name;
  delete properties.name;

  const setTracking = () => {
    Mixpanel.track(name, {
      host: window.location.host,
    });
  };
  return (
    <div onClick={setTracking}>
      <button {...properties} />
    </div>
  );
};
